<script>
import store from '@/store';

export default {
  languageTag() {
    if (store.state.config.selectedLanguage == 'spanish') {
      return 'es-ES';
    } else if (store.state.config.selectedLanguage == 'dutch') {
      return 'nl-NL';
    }
  },
  locale() {
    if (store.state.config.selectedLanguage == 'spanish') {
      return 'es';
    } else if (store.state.config.selectedLanguage == 'dutch') {
      return 'nl';
    }
  }
};
</script>
